import { render, staticRenderFns } from "./PlacedPolicies.vue?vue&type=template&id=1856415a&"
import script from "./PlacedPolicies.vue?vue&type=script&lang=js&"
export * from "./PlacedPolicies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports